class SearchHero {
  constructor() {
    this.selectors = {
      searchInput: '.heroRow--search input[type="search"]',
      resetButton: '.heroRow--search input[type="reset"]',
    };
  }

  handleClearInput() {
    // native input type search doesn't work on Firefox
    // using button type="reset"
    $(this.selectors.searchInput).on('keydown', () => {
      $(this.selectors.resetButton).addClass('show-flex');
    });

    $(this.selectors.resetButton).on('click', (e) => {
      $(e.currentTarget).removeClass('show-flex');
      $(this.selectors.searchInput).removeAttr('value');
    });

    if ($(this.selectors.searchInput).val() !== '') {
      $(this.selectors.resetButton).addClass('show-flex');
    }
  }

  init() {
    this.handleClearInput();
  }
}

export default new SearchHero();
